import _axios from './http'
const api = {
  //登录
  HJAccountLogin: (params) =>
    _axios.post(`server/api/Account/Login?isAdmin=${params.isAdmin}&account=${params.account}&password=${params.password}`, {}, true),

  //注册
  HJAccountRegister: (params) =>
    _axios.post(`server/api/Account/Register`, params, true),

  //修改密码
  HJAddOrUpdateManager: (params) =>
    _axios.post(`server/api/Account/AddOrUpdateManager`, params, true),

  //获取试题分类
  HJGetExamCategoryList: (params) =>
    _axios.get(`server/api/Exam/GetExamCategoryList?IsActive=${params.IsActive}`, {}, true),

  //添加或修改试题分类
  HJAddOrUpdateExamCategory: (params) =>
    _axios.post(`server/api/Exam/AddOrUpdateExamCategory`, params, true),

  //获取试卷统计详情
  HJGetExamPaperById: (params) =>
    _axios.post(`server/api/Exam/SelectExam?paperId=${params.paperId}`, {}, true),

  //获取开始考试的试卷试题列表
  HJStartExam: (params) =>
    _axios.post(`server/api/Exam/StartExam?paperId=${params.paperId}`, {}, true),

  //获取试题列表
  HJGetExamListByPaper: (params) =>
    _axios.get(`server/api/Exam/GetExamItemListByPaper?id=${params.id}`, {}, true),

  //获取试卷列表
  HJGetExamPaperListByCategory: (params) =>
    _axios.post(`server/api/Exam/ExamList?categoryId=${params.categoryId}`, {}, true),

  //获取下载分类
  HJGetAllExamInfor: (params) =>
    _axios.get(`server/api/ExamInfor/GetAllExamInfor?IsActive=${params.IsActive}`, {}, true),

  //获取下载列表
  HJGetExamInforDetail: (params) =>
    _axios.get(`server/api/ExamInfor/GetExamInforDetail?inforId=${params.inforId}`, {}, true),

  //交卷
  HJAddOrUpdateExamRecord: (params) =>
    _axios.post(`server/api/Exam/AddOrUpdateExamRecord`, params, true),

  //查看试卷
  HJCheckExam: (params) =>
  _axios.post(`server/api/Exam/CheckExam?paperId=${params.paperId}&recordId=${params.recordId}`, {}, true),

  //完成考试返回
  HJFinishExam: (params) =>
  _axios.post(`server/api/Exam/FinishExam?recordId=${params.recordId}`, {}, true),

  //已考列表
  HJExaminedPaperList: () =>
  _axios.post(`server/api/Exam/ExaminedPaperList`, {}, true),

//标记
HJAddExamMark: (params) =>
_axios.post(`server/api/Exam/AddExamMark`,params, true),

//取消标记
HJCancelExamMark: (params) =>
_axios.post(`server/api/Exam/CancelExamMark?recordId=${params.recordId}&itemId=${params.itemId}`,params, true),


//首页资料下载
HJGetExamInforTop: (params) =>
_axios.get(`server/api/ExamInfor/GetExamInforTop10`,params, true),

//资料下载统计
HJUpdateDownloadCount: (params) =>
_axios.post(`server/api/ExamInfor/UpdateDownloadCount?detailId=${params.detailId}`,params, true),


//全地区分级表
HJGetAllAddress: (params) =>
_axios.get(`server/api/Account/GetAllAddress`,params, true),


//获取全部学校
HJGetAllSchool: (params) =>
_axios.get(`server/api/Account/GetAllSchool`,params, true),

//获取已考分类
HJExaminedPaperList: (params) =>
_axios.post(`server/api/Exam/ExaminedPaperList?categoryId=${params.categoryId}`,params, true),

//获取已考分类下的列表
HJExaminedCategoryList: () =>
_axios.post(`server/api/Exam/ExaminedCategoryList`,{}, true),


}

export default api
